import React from 'react';
import { LogoIconProps } from './logo';

const JimKwik = ({ width = 184, className, color = 'var(--brand-950)', opacity = 0.5 }: LogoIconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 184 41'
    fill='none'
    className={className}
  >
    <g clipPath='url(#clip0_19134_12537)'>
      <path
        d='M15.4579 0.405396V40.4036L6.36743 35.4038V22.0408H9.64001V33.7675L12.1835 35.3129L12.1908 2.50166C12.3853 1.59261 14.6852 1.20718 15.2761 0.405396L15.4579 0.405396Z'
        fill='white'
      />
      <path
        d='M15.4579 0.405396V40.4036L6.36743 35.4038V22.0408H9.64001V33.7675L12.1835 35.3129L12.1908 2.50166C12.3853 1.59261 14.6852 1.20718 15.2761 0.405396L15.4579 0.405396Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M0.36792 8.95045L3.6405 7.13235V9.95041C3.6405 10.2395 4.34774 10.8522 4.68409 10.9176C7.30397 11.4394 6.07675 6.75237 6.39855 5.34334L9.64023 3.67615V19.2209L9.36751 19.4936H6.36765V12.8575C6.36765 11.3885 3.6405 11.6885 3.6405 12.8575V34.402L0.36792 32.5857V8.95045Z'
        fill='white'
      />
      <path
        d='M0.36792 8.95045L3.6405 7.13235V9.95041C3.6405 10.2395 4.34774 10.8522 4.68409 10.9176C7.30397 11.4394 6.07675 6.75237 6.39855 5.34334L9.64023 3.67615V19.2209L9.36751 19.4936H6.36765V12.8575C6.36765 11.3885 3.6405 11.6885 3.6405 12.8575V34.402L0.36792 32.5857V8.95045Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M18.3669 0.405396C18.9777 1.069 21.2795 1.68534 21.4522 2.50166L21.2776 38.8618L18.2778 40.4072L18.1851 0.405396H18.3669Z'
        fill='white'
      />
      <path
        d='M18.3669 0.405396C18.9777 1.069 21.2795 1.68534 21.4522 2.50166L21.2776 38.8618L18.2778 40.4072L18.1851 0.405396H18.3669Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M24.1849 3.85974L27.4574 5.95056L27.452 18.8554C27.5047 19.5172 24.9121 20.3099 25.2757 20.7662L27.4629 21.9844C27.7665 23.6243 26.9956 28.0114 27.5502 29.3113C28.1047 30.6113 30.1828 29.8949 30.1828 28.8604V7.13232C30.8682 7.61412 33.2917 8.48135 33.4499 9.22859L33.4608 32.4621L30.1846 34.222C30.1573 33.3166 30.4682 31.3349 29.3264 30.9894C26.5538 30.1513 27.7556 34.0329 27.3665 35.4965L24.183 37.3128V22.1316L21.6377 20.7662L24.183 19.3136V3.85974H24.1849Z'
        fill='white'
      />
      <path
        d='M24.1849 3.85974L27.4574 5.95056L27.452 18.8554C27.5047 19.5172 24.9121 20.3099 25.2757 20.7662L27.4629 21.9844C27.7665 23.6243 26.9956 28.0114 27.5502 29.3113C28.1047 30.6113 30.1828 29.8949 30.1828 28.8604V7.13232C30.8682 7.61412 33.2917 8.48135 33.4499 9.22859L33.4608 32.4621L30.1846 34.222C30.1573 33.3166 30.4682 31.3349 29.3264 30.9894C26.5538 30.1513 27.7556 34.0329 27.3665 35.4965L24.183 37.3128V22.1316L21.6377 20.7662L24.183 19.3136V3.85974H24.1849Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M130.907 12.9502L133.818 24.0388L136.996 13.1302L140.074 12.9393L143.18 24.0425L146.179 12.9502H149.452L144.732 29.5931L141.541 29.4968L138.723 19.3136L135.545 29.4968L132.351 29.5968L127.635 12.9502H130.907Z'
        fill='white'
      />
      <path
        d='M130.907 12.9502L133.818 24.0388L136.996 13.1302L140.074 12.9393L143.18 24.0425L146.179 12.9502H149.452L144.732 29.5931L141.541 29.4968L138.723 19.3136L135.545 29.4968L132.351 29.5968L127.635 12.9502H130.907Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M92.5455 12.9503H95.9999L95.7272 29.6768H92.7273V19.6773C91.8383 20.7463 88.0475 29.5714 87.3694 29.6932C87.0076 29.7568 86.384 29.7368 86.2004 29.3859L81.2733 19.8591V29.4041L81.0006 29.6768H78.0007V12.9503H81.1824L87.0003 24.0371L92.5455 12.9503Z'
        fill='white'
      />
      <path
        d='M92.5455 12.9503H95.9999L95.7272 29.6768H92.7273V19.6773C91.8383 20.7463 88.0475 29.5714 87.3694 29.6932C87.0076 29.7568 86.384 29.7368 86.2004 29.3859L81.2733 19.8591V29.4041L81.0006 29.6768H78.0007V12.9503H81.1824L87.0003 24.0371L92.5455 12.9503Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M111.272 12.9503V18.95L118.09 12.9503H122.544L113.635 21.039L122.908 29.6768H118.635L111.272 23.1317V29.6768H108.272L107.999 29.4041V12.9503H111.272Z'
        fill='white'
      />
      <path
        d='M111.272 12.9503V18.95L118.09 12.9503H122.544L113.635 21.039L122.908 29.6768H118.635L111.272 23.1317V29.6768H108.272L107.999 29.4041V12.9503H111.272Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M171.996 12.9503V18.95L178.814 12.9503H183.269L174.364 21.0409L183.632 29.6768H179.178L171.996 23.1317V29.6768H168.724V12.9503H171.996Z'
        fill='white'
      />
      <path
        d='M171.996 12.9503V18.95L178.814 12.9503H183.269L174.364 21.0409L183.632 29.6768H179.178L171.996 23.1317V29.6768H168.724V12.9503H171.996Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M57.2742 12.9503V27.586C57.2742 27.9387 56.407 28.9278 56.0942 29.1332C54.8743 29.935 47.9692 29.9623 46.7365 29.215C46.3329 28.9696 45.4565 27.8424 45.4565 27.4042V23.6771H48.4564C49.0218 24.3625 48.6091 25.5425 48.7291 26.4043H54.0016L54.1834 12.9503H57.2742Z'
        fill='white'
      />
      <path
        d='M57.2742 12.9503V27.586C57.2742 27.9387 56.407 28.9278 56.0942 29.1332C54.8743 29.935 47.9692 29.9623 46.7365 29.215C46.3329 28.9696 45.4565 27.8424 45.4565 27.4042V23.6771H48.4564C49.0218 24.3625 48.6091 25.5425 48.7291 26.4043H54.0016L54.1834 12.9503H57.2742Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M69.2738 12.9503V29.6768H66.2739L66.0012 29.4041V12.9503H69.2738Z'
        fill='white'
      />
      <path
        d='M69.2738 12.9503V29.6768H66.2739L66.0012 29.4041V12.9503H69.2738Z'
        fill={color}
        fillOpacity={opacity}
      />
      <path
        d='M159.997 12.9503V29.6768H156.997L156.724 29.4041V12.9503H159.997Z'
        fill='white'
      />
      <path
        d='M159.997 12.9503V29.6768H156.997L156.724 29.4041V12.9503H159.997Z'
        fill={color}
        fillOpacity={opacity}
      />
    </g>
    <defs>
      <clipPath id='clip0_19134_12537'>
        <rect
          width='183.264'
          height='40'
          fill='white'
          transform='translate(0.36792 0.405273)'
        />
      </clipPath>
    </defs>
  </svg>
);

export default JimKwik;
